var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "appliance"
    }
  }, [_c('div', {
    attrs: {
      "id": "shifting"
    }
  }, [_c('div', {
    staticClass: "payment-link-container"
  }, [_c('capusta-data-view', {
    attrs: {
      "label": _vm.$t('receive.transfer'),
      "description": _vm.project.payLink
    },
    on: {
      "click": _vm.onCopy
    }
  })], 1), _c('div', [_c('button', {
    staticClass: "settings",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'payment.settings'
        });
      }
    }
  }, [_vm._v(" Settings ")]), _c('button', {
    staticClass: "qr-code",
    on: {
      "click": function click($event) {
        return _vm.SET_MODAL_PARAMS({
          type: 'QR',
          params: {
            show: true,
            bill: {
              description: _vm.project.description
            },
            type: 'project',
            code: _vm.project.code
          }
        });
      }
    }
  }, [_vm._v(" QR Code ")]), _c('button', {
    staticClass: "share",
    on: {
      "click": function click($event) {
        _vm.SET_MODAL_PARAMS({
          type: 'SHARE',
          params: {
            show: true,
            shareInfo: {
              url: _vm.project.payLink,
              title: "".concat(_vm.$t('link.to.pay'), " | capusta.space"),
              description: _vm.project.description,
              showForm: false
            }
          }
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('to.share')) + " ")])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [!_vm.SELECTED_TRANSACTION.owner_id || _vm.isDesktop ? _c('div', {
    staticClass: "bill-created"
  }, [_c('a', {
    staticClass: "button thin action",
    class: {
      'disabled': _vm.isInactiveProject
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'Invoicing'
        });
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.create')))])])]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }